import axios from 'axios';

export const getmasterdetails = (server:any,request: any, callback: any) => {
    //const request = { "StoreId": "", "ItemKey": "pagemasthead" };
    const headers = {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
    };

    //axios.post(`https://xpstudio-api.g2p.pcf.dell.com/api/portal/getmasterdetails`, request, {
    //axios.post(`http://localhost:52249/api/portal/getmasterdetails`, request, {
    //axios.post(`http://p22vmctstools01.production.online.dell.com:1220/api/portal/getmasterdetails`, request, {
    axios.post(server + `/api/portal/getmasterdetails`, request, {
        headers: headers
    }).then(res => {
        if (res) {
            callback(res);
        }
    }).catch(error => {
        console.log(error);
        callback({ data: { data: null }, hasError: true });
    });
};

export const getsitedata = (server: any,request: any, callback: any) => {
    //const request = { "StoreId": "", "ItemKey": "pagemasthead" };
    const headers = {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
    };
    //axios.post(`https://xpstudio-api.g2p.pcf.dell.com/api/portal/GetSiteData`, request, {
    //axios.post(`http://localhost:52249/api/portal/GetSiteData`, request, {
    //axios.post(`http://p22vmctstools01.production.online.dell.com:1220/api/portal/GetSiteData`, request, {
    axios.post(`api/portal/GetSiteData`, request, {
        headers: headers
    }).then(res => {
        if (res) {
            callback(res);
        }
    }).catch(error => {
        console.log(error);
        callback({ data: { data: null }, hasError: true });
    });
};

export const getUserDetails = (callback: any) => {
    //const request = { "StoreId": "", "ItemKey": "pagemasthead" };
    const headers = {
        'Content-Type': 'application/json'
    };
    axios.get(`api/Permission/GetPermissions`, {
        headers: headers
    }).then(res => {
        if (res) {
            callback(res);
        }
    }).catch(error => {
        console.log(error);
        callback({ data: { data: null }, hasError: true });
    });
};

export const getContextDetails = (callback: any) => {
    const headers = {
        'Content-Type': 'application/json'
    };
    axios.get(`api/Permission/GetContextData`, {
        headers: headers
    }).then(res => {
        if (res) {
            callback(res);
        }
    }).catch(error => {
        console.log(error);
        callback({ data: { data: null }, hasError: true });
    });
};

export const getUserPermissionDetails = (request: any, callback: any) => {
    //const request = { "StoreId": "", "ItemKey": "pagemasthead" };
    const headers = {
        'Content-Type': 'application/json'
    };

    axios.post(`api/Permission/GetUserPermissions`, request, {
        headers: headers
    }).then(res => {
        if (res) {
            callback(res);
        }
    }).catch(error => {
        console.log(error);
        //callback({ data: { data: null }, hasError: true });
    });
};


export const getContentByKey = (url: string, request: any, callback: any, key: string, itemPath: string, isdataloading: boolean, apitype: string = "post", successHandlerScript: string = "") => {
    //const request = { "StoreId": "", "ItemKey": "pagemasthead" };
    const headers = {
        'Content-Type': 'application/json'
    };

    if (apitype.toLowerCase() === "get") {
        axios.get(url, {
            headers: headers
        }).then(res => {
            if (res) {
                callback(res, key, itemPath, isdataloading, successHandlerScript);
            }
        }).catch(error => {
            console.error(error);
            callback(null, key, itemPath, isdataloading, successHandlerScript);
        });
    }
    else {
        axios.post(url, request, {
            headers: headers
        }).then(res => {
            if (res) {
                callback(res, key, itemPath, isdataloading, successHandlerScript);
            }
        }).catch(error => {
            console.log(error);
            callback(null, key, itemPath, isdataloading, successHandlerScript);
        });
    }
};


export const createLayoutContent = (createTemplateAPI: any,callback: any) => {
    //const request = { "StoreId": "", "ItemKey": "pagemasthead" };
    const headers = {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
    };
    //axios.post('https://xpstudio-api.g2p.pcf.dell.com/api/clone/CreateContentTemplate', null, {
    axios.post(createTemplateAPI, null, {
        headers: headers
    }).then(res => {
        console.log("CreateLayoutContent Request Success");
        callback(res);
    }).catch(error => {
        console.log(error);
        console.log("CreateLayoutContent Request Error");
    });
};

export const getLinkUrl = (url: string, request: any, callback: any, callbackData: any) => {
    //const request = { "StoreId": "", "ItemKey": "pagemasthead" };
    const headers = {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
    };
    axios.post(url, request, {
        headers: headers
    }).then(res => {
        if (res) {
            callback(res, callbackData);
        }
    }).catch(error => {
        console.log(error);
        callback(null, callbackData);
    });
};

export const getItemDetails = (server: any,request: any, callback: any) => {
    //const request = { "StoreId": "", "ItemKey": "pagemasthead" };
    const headers = {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
    };

    //axios.post(`https://xpstudio-api.g2p.pcf.dell.com/api/portal/GetItemById`, request, {
    //axios.post(`http://localhost:52249/api/portal/GetItemById`, request, {
    axios.post(server + `/api/portal/GetItemById`, request, {
        headers: headers
    }).then(res => {
        if (res) {
            callback(res);
        }
    }).catch(error => {
        console.log(error);
        callback({ data: { data: null }, hasError: true });
    });
};